<div class="text-info-skeleton">
  <div class="text-info-skeleton__wrapper">
    <nr-skeleton [type]="'title'"></nr-skeleton>
    <div class="text-info-skeleton__paragraph">
      <nr-skeleton></nr-skeleton>
      <nr-skeleton [type]="'small'"></nr-skeleton>
    </div>
    <div class="text-info-skeleton__paragraph">
      <nr-skeleton></nr-skeleton>
      <nr-skeleton [type]="'small'"></nr-skeleton>
    </div>
    <nr-skeleton [type]="'button'"></nr-skeleton>
  </div>

  <div class="text-info-skeleton__wrapper">
    <nr-skeleton [type]="'title'"></nr-skeleton>
    <div class="text-info-skeleton__selectors">
      <nr-skeleton [type]="'selector'"></nr-skeleton>
      <nr-skeleton [type]="'selector'"></nr-skeleton>
    </div>
    <div class="text-info-skeleton__translation">
      <nr-skeleton [type]="'label'"></nr-skeleton>
      <nr-skeleton></nr-skeleton>
    </div>
    <div class="text-info-skeleton__translation">
      <nr-skeleton [type]="'label'"></nr-skeleton>
      <nr-skeleton></nr-skeleton>
    </div>
    <nr-skeleton [type]="'watermark'"></nr-skeleton>
  </div>
</div>
